module.exports = __webpack_public_path__ + "static/media/Slide50.c01fc764.JPG";